import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  useTheme,
} from '@mui/material'
import { ServiceMenuItem } from 'api/aws/service-menu/useServiceMenu'
import { useState } from 'react'
import { EDITABLE_FIELDS } from './defaultModels'
import './ServiceMenu.css'

interface ServiceMenuDialogProps {
  open: boolean
  item: Partial<ServiceMenuItem> | null
  onClose: () => void
  onSave: (data: Partial<ServiceMenuItem>) => void
  isSaving: boolean
}

const ServiceMenuDialog = ({ open, item, onClose, onSave, isSaving }: ServiceMenuDialogProps) => {
  const theme = useTheme()
  const [form, setForm] = useState<Record<string, any>>({})
  const isEdit = !!item?.PK

  const handleOpen = () => {
    if (item) {
      // Convert boolean ai_enhanced to string for the select
      setForm({ ...item, ai_enhanced: String(item.ai_enhanced ?? false) })
    } else {
      setForm({ status: 'Active', ai_enhanced: 'false' })
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth TransitionProps={{ onEnter: handleOpen }}>
      <DialogTitle>{isEdit ? 'Edit Service' : 'New Service'}</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '8px !important' }}>
        <Grid container spacing={2}>
          {EDITABLE_FIELDS.map(f => {
            if (f.type === 'select') {
              return (
                <Grid key={f.key} item xs={6}>
                  <FormControl key={f.key} size="small" fullWidth required={f.required}>
                    <InputLabel>{f.label}</InputLabel>
                    <Select
                      label={f.label}
                      value={form[f.key] ?? ''}
                      onChange={e => setForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                      MenuProps={{
                        sx: {
                          maxHeight: '350px',
                        },
                      }}
                    >
                      {f.options?.map(o => (
                        <MenuItem key={o.value} value={o.value}>
                          {o.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )
            }
            return (
              <Grid key={f.key} item xs={f.multiline ? 12 : 6}>
                <TextField
                  key={f.key}
                  label={f.label}
                  size="small"
                  fullWidth
                  required={f.required}
                  type={f.type === 'number' ? 'number' : 'text'}
                  multiline={!!f.multiline}
                  rows={f.multiline ? 3 : 1}
                  value={form[f.key] ?? ''}
                  onChange={e => setForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                  InputProps={{
                    sx: {
                      '& .MuiInputBase-root': {
                        padding: 0,
                      },
                    },
                  }}
                />
              </Grid>
            )
          })}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={isSaving} onClick={() => onSave(form)}>
          {isSaving ? 'Saving...' : isEdit ? 'Update' : 'Create'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export default ServiceMenuDialog
